module.exports = __webpack_public_path__ + "img/zhAward-3.592d1c9c.png";